// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__EventHandlers from "../../util/EventHandlers.js";
import * as Buhta_cabinet__Input from "./Input.js";
import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function label(size, isOpen, labelFloated, whiteMode) {
  return Cn.fromList({
    hd: "absolute top-0 left-2 transition ease-in-out z-1",
    tl: {
      hd: whiteMode ? "text-asphalt" : "text-white",
      tl: {
        hd: whiteMode ? (
            labelFloated ? "bg-white" : "bg-transparent"
          ) : "bg-asphalt-dark",
        tl: {
          hd: size === "m" ? Cn.on("text-sm !top-1 translate-x-2 translate-y-2", !labelFloated) : Cn.on("text-base leading-6 translate-x-2 translate-y-3", !labelFloated),
          tl: {
            hd: Cn.on("px-2 -translate-y-2 text-xs", labelFloated),
            tl: /* [] */ 0
          }
        }
      }
    }
  });
}

function select(size, isOpen, nowrap, whiteMode) {
  return Cn.fromList({
    hd: "relative border box-border rounded-sm transition-all ease-in-out duration-100",
    tl: {
      hd: isOpen ? "border-links" : "",
      tl: {
        hd: nowrap ? "border-transparent" : (
            whiteMode ? "border-gray-main" : (
                isOpen ? "border-white" : "border-asphalt"
              )
          ),
        tl: {
          hd: size === "m" ? "text-sm" : "text-base leading-6",
          tl: /* [] */ 0
        }
      }
    }
  });
}

function selectedOption(size, isOpen, nowrap, whiteMode) {
  return Cn.fromList({
    hd: "relative flex items-center justify-between rounded",
    tl: {
      hd: whiteMode ? "text-black" : "text-white",
      tl: {
        hd: size === "m" ? "py-2.5 px-4" : "py-3 pl-4 pr-4",
        tl: /* [] */ 0
      }
    }
  });
}

function options(isOpen, whiteMode) {
  return Cn.fromList({
    hd: "absolute top-full left-0 py-2 w-max max-h-72 overflow-y-scroll mt-1.5 z-10 rounded-sm shadow-card",
    tl: {
      hd: whiteMode ? "bg-white" : "bg-black",
      tl: {
        hd: isOpen ? "flex flex-col animate-fadeScaleIn" : "hidden",
        tl: /* [] */ 0
      }
    }
  });
}

function option(whiteMode) {
  return Cn.fromList({
    hd: "relative cursor-pointer",
    tl: {
      hd: whiteMode ? "py-1.5 px-4 hover:bg-gray-light" : "py-1 px-8 hover:bg-secondary",
      tl: /* [] */ 0
    }
  });
}

const Styles = {
  label: label,
  select: select,
  selectedOption: selectedOption,
  options: options,
  option: option
};

function Select$Activator(Props) {
  let size = Props.size;
  let nowrap = Props.nowrap;
  let selectedOption$1 = Props.selectedOption;
  let whiteMode = Props.whiteMode;
  let activatorRef = Props.activatorRef;
  let isOpen = Props.isOpen;
  let setIsOpen = Props.setIsOpen;
  let labelFloating = Props.labelFloating;
  let label$1 = Props.label;
  let selectedOptionClassName = Props.selectedOptionClassName;
  const labelFloated = labelFloating && (isOpen || selectedOption$1 !== undefined);
  return JsxRuntime.jsxs("div", {
    ref: activatorRef,
    children: [
      label$1 !== undefined && (labelFloating || selectedOption$1 === undefined) ? JsxRuntime.jsx("div", {
          children: label$1,
          className: label(size, isOpen, labelFloated, whiteMode)
        }) : null,
      JsxRuntime.jsx(Buhta_components__Text.Span.make, {
        nowrap: true,
        children: selectedOption$1 !== undefined ? selectedOption$1.text : null
      }),
      JsxRuntime.jsx("div", {
        children: whiteMode ? (
            isOpen ? JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/select-arrows-links.svg")
              }) : JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/select-arrows.svg")
              })
          ) : JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/select-arrows-white.svg")
          })
      })
    ],
    className: Cn.fromList({
      hd: selectedOption(size, isOpen, nowrap, whiteMode),
      tl: {
        hd: Cn.take(selectedOptionClassName),
        tl: /* [] */ 0
      }
    }),
    onClick: (function (param) {
      Curry._1(setIsOpen, (function (param) {
        return !isOpen;
      }));
    })
  });
}

const Activator = {
  make: Select$Activator
};

function Select$Wrapper(Props) {
  let nowrap = Props.nowrap;
  let className = Props.className;
  let isOpen = Props.isOpen;
  let setIsOpen = Props.setIsOpen;
  let size = Props.size;
  let selectedOption = Props.selectedOption;
  let whiteMode = Props.whiteMode;
  let activatorRef = Props.activatorRef;
  let children = Props.children;
  let labelFloating = Props.labelFloating;
  let label = Props.label;
  let selectedOptionClassName = Props.selectedOptionClassName;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Select$Activator, {
          size: size,
          nowrap: nowrap,
          selectedOption: selectedOption,
          whiteMode: whiteMode,
          activatorRef: activatorRef,
          isOpen: isOpen,
          setIsOpen: setIsOpen,
          labelFloating: labelFloating,
          label: label,
          selectedOptionClassName: selectedOptionClassName
        }),
        children
      ],
      className: Cn.fromList({
        hd: select(size, isOpen, nowrap, whiteMode),
        tl: {
          hd: "select",
          tl: /* [] */ 0
        }
      })
    }),
    className: Cn.fromList({
      hd: "relative select-none cursor-pointer",
      tl: {
        hd: Cn.on("pt-2", !nowrap),
        tl: {
          hd: Cn.take(className),
          tl: /* [] */ 0
        }
      }
    })
  });
}

const Wrapper = {
  make: Select$Wrapper
};

function Select$Options(Props) {
  let isOpen = Props.isOpen;
  let whiteMode = Props.whiteMode;
  let dropdownRef = Props.dropdownRef;
  let children = Props.children;
  return JsxRuntime.jsx("div", {
    ref: dropdownRef,
    children: children,
    className: options(isOpen, whiteMode)
  });
}

const Options = {
  make: Select$Options
};

function Select$Option(Props) {
  let whiteMode = Props.whiteMode;
  let onChange = Props.onChange;
  let option$1 = Props.option;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
      nowrap: true,
      className: whiteMode ? "text-black" : "text-white",
      children: option$1.text
    }),
    className: Cn.fromList({
      hd: option(whiteMode),
      tl: {
        hd: "relative",
        tl: /* [] */ 0
      }
    }),
    onClick: (function (param) {
      Curry._1(onChange, option$1);
    })
  });
}

function Select$Option$Label(Props) {
  let label = Props.label;
  let whiteMode = Props.whiteMode;
  let onChange = Props.onChange;
  if (label !== undefined) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: whiteMode ? "text-black" : "text-white",
        children: label
      }),
      className: option(whiteMode),
      onClick: (function (param) {
        Curry._1(onChange, undefined);
      })
    });
  } else {
    return null;
  }
}

const Label = {
  make: Select$Option$Label
};

const $$Option = {
  make: Select$Option,
  Label: Label
};

function make(className, options, label, nowrapOpt, sizeOpt, selectedOption, onChange, whiteModeOpt, labelFloatingOpt, nextFocusRef, $staropt$star) {
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const size = sizeOpt !== undefined ? sizeOpt : "l";
  const whiteMode = whiteModeOpt !== undefined ? whiteModeOpt : true;
  const labelFloating = labelFloatingOpt !== undefined ? labelFloatingOpt : true;
  if ($staropt$star === undefined) {
    false;
  }
  return function (selectedOptionClassName) {
    const match = React.useState(function () {
      return false;
    });
    const setIsOpen = match[1];
    const isOpen = match[0];
    const onChange$1 = function (selectedOption) {
      Curry._1(setIsOpen, (function (param) {
        return false;
      }));
      Curry._1(onChange, selectedOption);
      if (nextFocusRef === undefined) {
        return;
      }
      const __x = nextFocusRef.current;
      Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
        return el.focus();
      }));
    };
    const activatorRef = React.useRef(null);
    const inputRef = React.useRef(null);
    const dropdownRef = React.useRef(null);
    Buhta_cabinet__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
      Curry._1(setIsOpen, (function (param) {
        return false;
      }));
    }));
    const match$1 = React.useState(function () {
      return 0;
    });
    const setFocusedOptionIndex = match$1[1];
    const focusedOptionIndex = match$1[0];
    React.useEffect((function () {
      if (isOpen) {
        const __x = inputRef.current;
        Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
          return el.focus();
        }));
      }
      
    }), [isOpen]);
    let tmp = {
      nowrap: nowrap,
      isOpen: isOpen,
      setIsOpen: setIsOpen,
      size: size,
      selectedOption: selectedOption,
      whiteMode: whiteMode,
      activatorRef: activatorRef,
      children: [
        JsxRuntime.jsx("input", {
          ref: inputRef,
          className: "absolute w-0 h-0 outline-hidden",
          type: "button",
          onKeyDown: (function ($$event) {
            const match = $$event.key;
            switch (match) {
              case "ArrowDown" :
                if (focusedOptionIndex !== (Belt__Belt_List.length(options) - 1 | 0)) {
                  return Curry._1(setFocusedOptionIndex, (function (param) {
                    return focusedOptionIndex + 1 | 0;
                  }));
                } else {
                  return Curry._1(setFocusedOptionIndex, (function (param) {
                    return 0;
                  }));
                }
              case "ArrowUp" :
                if (focusedOptionIndex !== 0) {
                  return Curry._1(setFocusedOptionIndex, (function (param) {
                    return focusedOptionIndex - 1 | 0;
                  }));
                } else {
                  return Curry._1(setFocusedOptionIndex, (function (param) {
                    return Belt__Belt_List.length(options) - 1 | 0;
                  }));
                }
              case "Enter" :
                onChange$1(Belt__Belt_List.getExn(options, focusedOptionIndex));
                $$event.preventDefault();
                return;
              case "Tab" :
                Curry._1(setIsOpen, (function (param) {
                  return false;
                }));
                if (nextFocusRef === undefined) {
                  return;
                }
                const __x = nextFocusRef.current;
                Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
                  return el.focus();
                }));
                return;
              default:
                return;
            }
          }),
          onFocus: (function (param) {
            Curry._1(setIsOpen, (function (param) {
              return true;
            }));
            Curry._1(setFocusedOptionIndex, (function (param) {
              return 0;
            }));
          }),
          onBlur: (function (param) {
            
          })
        }),
        JsxRuntime.jsxs(Select$Options, {
          isOpen: isOpen,
          whiteMode: whiteMode,
          dropdownRef: dropdownRef,
          children: [
            JsxRuntime.jsx(Select$Option$Label, {
              label: label,
              whiteMode: whiteMode,
              onChange: onChange$1
            }),
            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(options, (function (index, option) {
              const Key = "select-item" + String(index);
              return JsxRuntime.jsx(Select$Option, {
                whiteMode: whiteMode,
                onChange: onChange$1,
                isFocused: index === focusedOptionIndex,
                option: option
              }, Key);
            })))
          ]
        })
      ],
      labelFloating: labelFloating,
      label: label
    };
    if (className !== undefined) {
      tmp.className = Caml_option.valFromOption(className);
    }
    if (selectedOptionClassName !== undefined) {
      tmp.selectedOptionClassName = Caml_option.valFromOption(selectedOptionClassName);
    }
    return JsxRuntime.jsxs(Select$Wrapper, tmp);
  };
}

function Select(Props) {
  return make(Props.className, Props.options, Props.label, Props.nowrap, Props.size, Props.selectedOption, Props.onChange, Props.whiteMode, Props.labelFloating, Props.nextFocusRef, Props.disabled)(Props.selectedOptionClassName);
}

function Select$Searchable(Props) {
  let className = Props.className;
  let label = Props.label;
  let useFetch = Props.useFetch;
  let mapper = Props.mapper;
  let nowrapOpt = Props.nowrap;
  let sizeOpt = Props.size;
  let selectedOption = Props.selectedOption;
  let onChange = Props.onChange;
  let whiteModeOpt = Props.whiteMode;
  let labelFloatingOpt = Props.labelFloating;
  let $staropt$star = Props.disabled;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const size = sizeOpt !== undefined ? sizeOpt : "l";
  const whiteMode = whiteModeOpt !== undefined ? whiteModeOpt : true;
  const labelFloating = labelFloatingOpt !== undefined ? labelFloatingOpt : true;
  if ($staropt$star === undefined) {
    false;
  }
  const match = React.useState(function () {
    return false;
  });
  const setIsOpen = match[1];
  const isOpen = match[0];
  const onChange$1 = function (selectedOption) {
    Curry._1(setIsOpen, (function (param) {
      return false;
    }));
    Curry._1(onChange, selectedOption);
  };
  const match$1 = React.useState(function () {
    return "";
  });
  const setSearchText = match$1[1];
  const searchText = match$1[0];
  const match$2 = React.useState(function () {
    return {
      filter: {
        hd: [
          "query",
          searchText
        ],
        tl: /* [] */ 0
      },
      params: undefined
    };
  });
  const setParams = match$2[1];
  React.useEffect((function () {
    Curry._1(setParams, (function (param) {
      return {
        filter: {
          hd: [
            "query",
            searchText
          ],
          tl: /* [] */ 0
        },
        params: undefined
      };
    }));
  }), [searchText]);
  const match$3 = Curry._3(useFetch, undefined, match$2[0], undefined);
  const options = match$3[0];
  const activatorRef = React.useRef(null);
  const dropdownRef = React.useRef(null);
  Buhta_cabinet__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
    Curry._1(setIsOpen, (function (param) {
      return false;
    }));
  }));
  let tmp;
  if (typeof options === "string") {
    tmp = JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {
      primaryColor: "border-white"
    });
  } else if (options.NAME === "Data") {
    const __x = Belt__Belt_List.map(options.VAL.data, mapper);
    tmp = Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, option) {
      const Key = "select-item" + String(index);
      return JsxRuntime.jsx(Select$Option, {
        whiteMode: whiteMode,
        onChange: onChange$1,
        option: option
      }, Key);
    })));
  } else {
    tmp = JsxRuntime.jsx(Buhta_components__Text.H3.make, {
      children: options.VAL.message
    });
  }
  let tmp$1 = {
    nowrap: nowrap,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    size: size,
    selectedOption: selectedOption,
    whiteMode: whiteMode,
    activatorRef: activatorRef,
    children: JsxRuntime.jsxs(Select$Options, {
      isOpen: isOpen,
      whiteMode: whiteMode,
      dropdownRef: dropdownRef,
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              alt: "icon",
              src: StaticAsset.src("/static/icons/search.svg")
            }),
            JsxRuntime.jsx(Buhta_cabinet__Input.make, {
              className: "ml-2",
              value: searchText,
              placeholder: "Поиск..",
              darkMode: !whiteMode,
              onChange: (function (value) {
                Curry._1(setSearchText, (function (param) {
                  return value;
                }));
              })
            })
          ],
          className: "flex items-center py-2.5 px-4"
        }),
        tmp
      ]
    }),
    labelFloating: labelFloating,
    label: label
  };
  if (className !== undefined) {
    tmp$1.className = Caml_option.valFromOption(className);
  }
  return JsxRuntime.jsx(Select$Wrapper, tmp$1);
}

const Searchable = {
  make: Select$Searchable
};

function findInList(options, value) {
  return Belt__Belt_List.getBy(options, (function (option) {
    return Caml_obj.caml_equal(option.value, value);
  }));
}

function findSomeInList(options, value) {
  return Belt__Belt_Option.mapWithDefault(value, undefined, (function (value) {
    return Belt__Belt_List.getBy(options, (function (option) {
      return Caml_obj.caml_equal(option.value, value);
    }));
  }));
}

const make$1 = Select;

export {
  Styles,
  Activator,
  Wrapper,
  Options,
  $$Option,
  make$1 as make,
  Searchable,
  findInList,
  findSomeInList,
}
/* Buhta_cabinet__EventHandlers Not a pure module */
